'use strict';

var ChartDemandTransparencyViewport = function ChartDemandTransparencyViewport(ChartViewport, chartXAxis, chartGroups, chartSimpleBars, chartSimpleBarsOverlays) {
  var chartParams = require('./ParamsViewport');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    var groups = chartGroups('d1').asViewport();
    var simpleBars = chartSimpleBars('m1');
    var simpleBarsOverlays = chartSimpleBarsOverlays('m1');
    var xAxis = chartXAxis(formatters.xAxisViewportFormatter).withRepetition(1).withoutLine();
    ChartViewport.call(this, container, chartParams, chartScales, groups, simpleBars, simpleBarsOverlays, xAxis);
  };
  Chart.prototype = Object.create(ChartViewport.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartDemandTransparencyViewport.$inject = ['ChartViewport', 'ChartElementsXAxis', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsSimpleBarsOverlays'];
module.exports = ChartDemandTransparencyViewport;